import { genericJourneyResolverMapping } from '@dxb-web-ui-framework/mocks/msw/types';
import { genericMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/genericMapToHandlers';
import { ecommbx } from '../../index';

const accountMap: genericJourneyResolverMapping[] = [
  {
    url: /\/api\/private\/accounts\/certificate\/\d+/,
    response: () => ecommbx.accountIbanCertificateData,
    method: 'get',
  },
  {
    url: /\/api\/private\/accounts\/\d+\/deposits\/\d+/,
    response: () => ecommbx.accountDetailsData,
    method: 'get',
  },
  { url: /\/api\/private\/accounts\/\d+\/deposits/, response: () => ecommbx.accountsListData, method: 'get' },
  { url: /\/api\/private\/accounts\/dashboard/, response: () => ecommbx.dashboardData, method: 'get' },
  {
    url: /\/api\/private\/accounts\/alias\/\d+\/+d/,
    response: () => ecommbx.upsertAliasData,
    method: 'put',
  },
  {
    url: /\/api\/private\/accounts\/alias\/\d+\/+d/,
    response: () => ecommbx.deleteAliasData,
    method: 'delete',
  },
  { url: /\/api\/private\/accounts\/currencies\/active/, response: () => ecommbx.activeCurrenciesData, method: 'get' },
  { url: /\/api\/private\/accounts\/products/, response: () => ecommbx.productsData, method: 'get' },
  { url: /\/api\/private\/accounts/, response: () => ecommbx.requestIbanAccount, method: 'post' },
];

const accountHandlers = accountMap.map(genericMapToHandlers);

export { accountHandlers };
